import { ROUTES } from '../lib/routes'

export type ToolLink = {
  href: (typeof ROUTES)[keyof typeof ROUTES]
  label: string
  shortLabel: string
  description: string
  popular?: boolean
}

export const TOOL_LINKS: ToolLink[] = [
  // Linha 1: Ferramentas principais (maior demanda)
  {
    href: ROUTES.mergePdf,
    label: 'Juntar PDF',
    shortLabel: 'Juntar',
    description: 'Una vários PDFs em um só.',
    popular: true,
  },
  {
    href: ROUTES.compressPdf,
    label: 'Comprimir PDF',
    shortLabel: 'Comprimir',
    description: 'Reduza o tamanho do arquivo mantendo a qualidade.',
    popular: true,
  },
  {
    href: ROUTES.signPdf,
    label: 'Assinar PDF',
    shortLabel: 'Assinar',
    description: 'Adicione sua assinatura a qualquer documento PDF.',
    popular: true,
  },
  // Linha 2: Conversões e Divisão
  {
    href: ROUTES.pdfToJpg,
    label: 'PDF para JPG/PNG',
    shortLabel: 'PDF → Imagem',
    description: 'Exporte páginas como JPG ou PNG (ZIP para várias).',
    popular: true,
  },
  {
    href: ROUTES.jpgToPdf,
    label: 'JPG/PNG para PDF',
    shortLabel: 'Imagem → PDF',
    description: 'Converta imagens em PDF; reordene facilmente.',
  },
  {
    href: ROUTES.splitPdf,
    label: 'Dividir PDF',
    shortLabel: 'Dividir',
    description: 'Divida por intervalo de páginas ou cada página.',
  },
  // Linha 3: Ferramentas utilitárias
  {
    href: ROUTES.rotatePdf,
    label: 'Girar PDF',
    shortLabel: 'Girar',
    description: 'Gire páginas selecionadas ou todo o arquivo.',
  },
  {
    href: ROUTES.deletePdfPages,
    label: 'Excluir páginas PDF',
    shortLabel: 'Excluir páginas',
    description: 'Exclua páginas específicas de um PDF.',
  },
]
